import React from "react";

export const DashboardContainer = (props) => {
	return (
		<div className="wrap pt20 pb10">
			{props.children}
		</div>
	)
};

